// API文档相关API
import request from '@/api'

// 发布文章
export async function articleAdd(data) {
  return request({
    url: '/capi/community/article/add',
    method: 'post',
    data
  })
}
// 查询频道
export async function channelFind(data) {
  return request({
    url: '/capi/community/channel/findAll',
    method: 'post',
    data
  })
}
// 查询标签
export async function getLabel(data) {
  return request({
    url: '/capi/label/v1/tag/batchQuery',
    method: 'post',
    data
  })
}
// 文章详情
export async function getArticle(id) {
  return request({
    url: `/capi/community/article/get/${id}`,
    method: 'post'
  })
}
// 分页查询文章
export async function findPage(data, num, size) {
  return request({
    url: `/capi/community/article/findPage?pageNum=${num}&pageSize=${size}`,
    method: 'post',
    data
  })
}
// 分页查询评论
export async function findPageComment(data, num, size) {
  return request({
    url: `/capi/community/article/findPageComment?pageNum=${num}&pageSize=${size}`,
    method: 'post',
    data
  })
}
// 按点赞查询
export async function findPageThumbs(data, num, size) {
  return request({
    url: `/capi/community/article/findPageThumbs?pageNum=${num}&pageSize=${size}`,
    method: 'post',
    data
  })
}
// 收藏
export async function collection(data) {
  return request({
    url: `/capi/community/collection`,
    method: 'post',
    data
  })
}
// 举报
export async function tipOffs(data) {
  return request({
    url: `/capi/community/tipOffs`,
    method: 'post',
    data
  })
}
// 统计收藏数量
export async function countCollection(data) {
  return request({
    url: `/capi/community/collection/count`,
    method: 'post',
    data
  })
}
// 添加评论
export async function addComment(data) {
  return request({
    url: `/capi/community/comment/add`,
    method: 'post',
    data
  })
}
// 点赞
export async function thumbs(data) {
  return request({
    url: `/capi/community/thumbs`,
    method: 'post',
    data
  })
}
// 统计点赞数量
export async function countThumbs(data) {
  return request({
    url: `/capi/community/thumbs/count`,
    method: 'post',
    data
  })
}
// 文章搜索
export async function search(data) {
  return request({
    url: `/capi/community/index/search?keyword=${data.keyword}&pageNum=${data.pageNum}&pageSize=${data.pageSize}&type=article&channel=${data.channel}&status=${data.status}`,
    method: 'get',
    data
  })
}
// 评论组合查询
export async function getComments(data, num, size, id) {
  return request({
    url: `/capi/community/comment/comments?pageNum=${num}&pageSize=${size}&userId=${id}`,
    method: 'post',
    data
  })
}
// 获取用户等级
export async function selectPersonalLevel(data) {
  return request({
    url: `/capi/web-service/experience/selectPersonalLevel`,
    method: 'post',
    data
  })
}
// 获取用户信息
export async function selectPersonalInfo(data) {
  return request({
    url: `/capi/web-service/experience/selectPersonalInfo `,
    method: 'post',
    data
  })
}
// 查询全部文章
export async function findAll(data) {
  return request({
    url: `/capi/community/article/findAll`,
    method: 'post',
    data
  })
}
// 删除文章
export async function delArticle(id) {
  return request({
    url: `/capi/community/article/del/${id}`,
    method: 'post'
  })
}
// 删除文章
export async function findComment(data, num, size) {
  return request({
    url: `/capi/community/comment/findPage?pageNum=${num}&pageSize=${size}`,
    method: 'post',
    data
  })
}
// 查询指定用户和文章评论
export async function findComments(data) {
  return request({
    url: `/capi/community/comment/findComments`,
    method: 'post',
    data
  })
}
// 获取频道
export async function getChannel(id) {
  return request({
    url: `/capi/community/channel/get/${id}`,
    method: 'post'
  })
}
// 删除评论
export async function delComment(id) {
  return request({
    url: `/capi/community/comment/del/${id}`,
    method: 'post'
  })
}
// 更新文章
export async function updateArticle(data) {
  return request({
    url: `/capi/community/article/update`,
    method: 'post',
    data
  })
}
// 更新评论
export async function updateComment(data) {
  return request({
    url: `/capi/community/comment/update`,
    method: 'post',
    data
  })
}
export async function getUserInfo(id) {
  return request({
    url: `/capi/c-access-layer/account/getUserInfo?userid=${id}`,
    method: 'post'
  })
}
// 获取banner图地址
export async function getBannerURL(data) {
  return request({
    url: `/capi/template-center/material/detail?id=${data.id}`,
    method: 'get',
    data
  })
}
// 更新文章
export async function updateArticleStatus(data) {
  return request({
    url: `/capi/community/article/status`,
    method: 'post',
    data
  })
}
